export const requiredField = (name: any) => (value: any) => value ? undefined : `${name} is required`
export const emailValidation = (value: any) => !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) ? 'Enter valid email' : undefined
export const validatePasswordMatch = (value: any, allValues: any) => {
    if (!(allValues.password === allValues.confirm_password) || !(allValues.password === allValues.confirm_password)) {
        return "Passwords did't match";
    }
}